const actions = {
  SET_STATE: 'games/SET_STATE',
  GET_GAMES: 'games/GET_GAMES',
  GET_INDICATORS: 'games/GET_INDICATORS',
  SET_OPERATIONS_GAME: 'games/SET_OPERATIONS_GAME',
  SET_OPERATIONS_GAME_EXIT: 'games/SET_OPERATIONS_GAME_EXIT',
}

export default actions
